import { useTranslation } from 'react-i18next';
import { UtilityDrawerHookReturnType } from '../../utility-drawer/utility-drawer.hooks';
import FormDrawer, {
  FormDrawerProps,
} from '../../form-drawer/form-drawer.component';
import { useLocationHoursContext } from 'components/location-hours/location-hours.context';
import { SetHoursFormDataProps } from 'components/location-hours/location-hours.utils';
import SetClosedDatesForm from 'components/forms/location/hours/set-closed-dates-form/set-closed-dates-form.component';
import { useSetClosedDatesForm } from 'components/forms/location/hours/set-closed-dates-form/set-closed-dates-form.hooks';

type SetClosedDatesDrawerProps = {
  drawerData: SetHoursFormDataProps;
} & Omit<FormDrawerProps, 'children' | 'onClose' | 'formMethods' | 'onValid'> &
  UtilityDrawerHookReturnType;

const SetClosedDatesDrawer = ({
  title,
  open,
  close,
  drawerData,
  ...rest
}: SetClosedDatesDrawerProps) => {
  const { t } = useTranslation();
  const {
    closedDates: { removeDummyEvent, addEvents },
  } = useLocationHoursContext();
  const { form } = useSetClosedDatesForm(drawerData);

  const finalOnValid = data => {
    try {
      removeDummyEvent();
      addEvents(data);

      form.reset();
      close();
    } catch (_e) {}
  };

  const cancel = () => {
    removeDummyEvent();

    form.reset();
    form.clearErrors();
    close();
  };

  return (
    <FormDrawer
      title={t('drawer.setClosedDatesDrawer.title')}
      data-testid="SetClosedDatesDrawer"
      submitButtonLabel={t('drawer.setClosedDatesDrawer.buttons.apply')}
      open={open}
      onValid={finalOnValid}
      onClose={cancel}
      cancel={cancel}
      formMethods={form}
      {...rest}
    >
      {open && <SetClosedDatesForm />}
    </FormDrawer>
  );
};

export default SetClosedDatesDrawer;
